import {mosquito} from './Mosquito';
import {combate} from './Combate';
import {dengue} from './Dengue';
import {febre_amarela} from './Febre_amarela';
import {zika} from './Zika';
import {chikungunya} from './Chikungunya';

function useGetData(puzzle){
  switch (puzzle) {
    case "mosquito":
      return mosquito();
    case "combate":
      return combate();
    case "dengue":
      return dengue();
    case "febre_amarela":
      return febre_amarela();
    case "zika":
      return zika();
    case "chikungunya":
      return chikungunya();
    default:
      return false;
  }
}

export{useGetData};
